import { render, staticRenderFns } from "./create-notice.vue?vue&type=template&id=18db4022&scoped=true&lang=html&"
import script from "./create-notice.vue?vue&type=script&lang=js&"
export * from "./create-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db4022",
  null
  
)

export default component.exports